import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../App";
import { store } from "../app/store";
import { SOCKET, socketPairTopicPrefix } from "../constants/constants";
import { setPairList } from "../features/ats/atsSlice";
import { setFavPairList } from "../features/persist/persistSlice";
import { parseJSON } from "../helpers/commonHelper";

function pairMatchesSocket(item, socketPair) {
  if (!item || !socketPair) return false;
  const normalized = String(socketPair).trim().toLowerCase();
  const candidates = [item.pair_key, item.pair_name, item.name].filter(Boolean);
  return candidates.some(
    (key) => socketPairTopicPrefix(key).toLowerCase() === normalized
  );
}

function applyChange24ToPairs(pairs, payload) {
  if (!Array.isArray(pairs) || !payload?.pair) return { pairs, changed: false };

  let changed = false;
  const next = pairs.map((item) => {
    if (!pairMatchesSocket(item, payload.pair)) return item;
    changed = true;
    return {
      ...item,
      change_24hour: payload.change_24hour,
      priceChangePercent: payload.priceChangePercent,
      change: payload.priceChangePercent,
    };
  });

  return { pairs: changed ? next : pairs, changed };
}

/**
 * Applies global CHANGE24 socket updates to watch list pair rows.
 * Socket pair format: ttrx_tarcusdc — REST pair_key: ttrx/tarcusdc.
 */
export function useWatchListSocket() {
  const dispatch = useDispatch();
  const isUserLogin = useSelector((state) => state?.persist?.isUserLogin);

  useEffect(() => {
    if (!isUserLogin) return undefined;

    const onChange24 = (payload) => {
      if (!payload?.pair) return;

      const state = store.getState();
      const currentPairs = state?.ats?.pairList ?? [];
      const currentFav = state?.persist?.favPairList ?? [];

      if (currentPairs.length) {
        const { pairs, changed } = applyChange24ToPairs(
          parseJSON(currentPairs),
          payload
        );
        if (changed) dispatch(setPairList(pairs));
      }

      if (currentFav.length) {
        const { pairs, changed } = applyChange24ToPairs(
          parseJSON(currentFav),
          payload
        );
        if (changed) dispatch(setFavPairList(pairs));
      }
    };

    socket.on(SOCKET.CHANGE24, onChange24);
    console.log("[useWatchListSocket] listening", SOCKET.CHANGE24);

    return () => {
      socket.off(SOCKET.CHANGE24, onChange24);
    };
  }, [dispatch, isUserLogin]);
}

export default useWatchListSocket;
